module.exports = __webpack_public_path__ + "static/img/blcj.e7a4725.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blcj.jpg
// module id = e6dZ
// module chunks = 3